const QR_CODE_SIZE = 88; // Size of the QR Code in pixels

/**
 * Creates Melhor Ponto QR Code, if element ".melhor-ponto-code" is present in the DOM
 */
const melhorPontoQrCode = {
  computed: {
    hasAdditionalInfo: function() {
      return !!(
        this.$parent.tag &&
        this.$parent.tag.additionalInfo &&
        this.$parent.tag.additionalInfo.volume
      );
    },
    hasVolume: function() {
      return !!(this.$parent.volume && this.$parent.volume.seqVolume);
    },
    hasIndex: function() {
      return !!(
        this.$parent.tag && typeof this.$parent.tag.volumeIndex === "number"
      );
    },
    hasTotal: function() {
      return !!(this.$parent.tag && this.$parent.tag.volumeTotal);
    },
    /**
     * Computed property that returns the number of volumes
     * @returns {String} Number of volumes (if available) or "1/1" which is the default value
     */
    volumeNumbers: function() {
      if (this.hasAdditionalInfo && this.hasVolume) {
        return `${this.$parent.volume.seqVolume
          .toString()
          .padStart(
            3,
            "0"
          )}/${this.$parent.tag.additionalInfo.volume.length
          .toString()
          .padStart(3, "0")}`;
      }

      if (this.hasIndex && this.hasTotal) {
        return `${this.$parent.tag.volumeIndex + 1}/${
          this.$parent.tag.volumeTotal
        }`;
      }

      return "1/1";
    }
  },
  methods: {
    /**
     * Method that creates the Melhor Ponto QR Code with all the necessary information
     * if the element ".melhor-ponto-code" is present in the DOM
     * @returns {void}
     */
    createQrCode() {
      const element = this.$el.querySelector(".melhor-ponto-code");
      
      if (!element) return;

      let value = "https://melhorenvio.com.br";

      let mpCode = this.$parent.mpCode;
      
      if (mpCode) {
        value = mpCode;
      }
    
      QRCode.toCanvas(element, value, {
        width: this.mpQrCodeSize || QR_CODE_SIZE,
        margin: 0,
      });
    }
  },
  mounted() {
    this.createQrCode();
  }
};

export default melhorPontoQrCode;
